module.exports = __webpack_public_path__ + "media/images/icons/filled/pound-circle-5b02a9ed8f4be240d85ceae421aa1626.svg";